import type { Document, Stored } from "@overmap-ai/common"
import { Mention } from "@tiptap/extension-mention"
import { mergeAttributes, ReactNodeViewRenderer } from "@tiptap/react"

import type { MentionOptions } from "../typings"
import { DocumentMentionComponent } from "./Component"
import { suggestion } from "./suggestion"

export const DocumentMention = Mention.extend<MentionOptions<Stored<Document>>>({
	name: "DocumentMention",
	atom: true,
	addAttributes() {
		return {
			uuid: {
				default: null,
			},
		}
	},
	parseHTML() {
		return [
			{
				tag: "document-mention",
			},
		]
	},
	renderHTML({ HTMLAttributes }) {
		return ["document-mention", mergeAttributes(HTMLAttributes)]
	},
	addNodeView() {
		return ReactNodeViewRenderer(DocumentMentionComponent)
	},
}).configure({
	suggestion,
})
